import(/* webpackMode: "eager" */ "/alias-labs/app/globals.css");
import(/* webpackMode: "eager" */ "/alias-labs/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/alias-labs/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/alias-labs/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/alias-labs/components/ui/tooltip.tsx")